import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getLegalMarkdown } from '../api/client';
import { LegalMarkdown } from './LegalMarkdown';
import LegalPageShell, { LegalFallback } from '../components/celestial/LegalPageShell';

export default function ChildSafety() {
  const [searchParams] = useSearchParams();
  const langTr = searchParams.get('lang') === 'tr';
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    getLegalMarkdown('child-safety-standards', { lang: langTr ? 'tr' : 'en' })
      .then((text) => setMarkdown((text || '').trim()))
      .catch((e) => setError(e instanceof Error ? e.message : 'Metin yüklenemedi'))
      .finally(() => setLoading(false));
  }, [langTr]);

  return (
    <LegalPageShell title={langTr ? 'Çocuk Güvenliği Standartları' : 'Child Safety Standards'}>
      <p className="celestial-body-lg" style={{ fontSize: '0.95rem' }}>
        {langTr ? (
          <>
            English version:{' '}
            <Link to="/child-safety">Child Safety Standards (EN)</Link>
          </>
        ) : (
          <>
            Türkçe:{' '}
            <Link to="/child-safety?lang=tr">Çocuk Güvenliği Standartları</Link>
          </>
        )}
      </p>
      {loading && <p>Yükleniyor…</p>}
      {error && <div className="celestial-error">{error}</div>}
      {markdown ? <LegalMarkdown content={markdown} /> : null}
      {!loading && !markdown && (
        <LegalFallback
          href="https://api.astroai.work/api/legal/child-safety-standards"
          label="API bağlantısı"
        />
      )}
    </LegalPageShell>
  );
}
